import { Component, OnInit, ViewChild } from '@angular/core';
import { FileService } from '../services/file.service';
import { TipologiaMenu, TipologiaSubMenu, CustomValue, TipologiaDto, Documento, AttachmentDto, TipologiaUserManualsDto } from '../models/data.model';
import { DataService } from '../services/data.service';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from '../services/common.service';
import { MimetypeService } from '../services/mimetype.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-international-activities',
  templateUrl: './international-activities-usermanuals.component.html',
  styleUrls: ['./international-activities-usermanuals.component.css']
})
export class InternationalActivitiesUsermanualsComponent implements OnInit {

  @ViewChild('Prod') ProdElement;
  @ViewChild('Disc') DiscElement;
  @ViewChild('All') AllElement;

  @ViewChild('DynamicForm') DynamicFormElement;
  @ViewChild('DynamicInput') DynamicInputElement;


  srch: Documento = null;

  public internationalActivitiesUserManualsFilter: any = '';

  idTipologia: number;
  tipologia: any;
  documentType: string;
  documents: Documento[] = [];

  constructor(private idTipologieService: FileService,
    private activatedRoute: ActivatedRoute,
    private dataService: DataService,
    private tipologiaService: CommonService<TipologiaUserManualsDto>,
    private distinctValueService: CommonService<CustomValue>,
    private documentService: CommonService<Documento>,
    private fileServer: CommonService<AttachmentDto>,
    private mimeTypeService: MimetypeService,
    private toastr: ToastrService,
    public translate: TranslateService) { }

  tipologies: TipologiaMenu[] = [];
  isExpanded = false;
  lineaProdotto: string;
  //selecteditem: TipologiaSubMenu = null;
  modelList: string[] = [];
  classificationList: string[] = [];
  isShowResultButton: boolean = false;
  filter: string = "All models"
  fullLinea: string;
  area: string;
  models: string[] = [];
  modelsFiltered: string[] = [];
 

  modelSelected: string = 'All models';
  valueSearchSelected: string;

  selected: any = {
    item: null,
    model: null,
    classification: null,
    textToSearch: null,
  }
  selectedFromInput: string;


  ngOnInit() {
    //Temporary if they want exact refer to fullLinea
    this.fullLinea = this.activatedRoute.snapshot.paramMap.get('linea');
    let fullLineaSplited = this.fullLinea.split('_');
    this.lineaProdotto = fullLineaSplited[0];
    let sectionArea = fullLineaSplited[1];

    this.tipologies = [];
    this.idTipologieService.getAllIdTipologieUserManuals().subscribe(data => //Call our public function
    {
      Object.keys(data).forEach(key => {
        console.log('this.lineaProdotto: ', this.lineaProdotto);
        console.log('key: ', key);
        console.log('data[key]: ', data[key]);
        if (key === this.lineaProdotto) {
          this.idTipologia = data[key];
       
    
    //switch (this.lineaProdotto) {
    //  case "US":
    //    this.idTipologia = 8; // Produzione e colaudo
    //    //this.idTipologia = 1028; // Sviluppo
    //    break;
    //  case "MRI":
    //    this.idTipologia = 19;
    //    break;
    //  case "VET":
    //    this.idTipologia = 20;
    //    break;
    //  case "XRAY":
    //    this.idTipologia = 52;
    //    break;
    //  default:      
    //}
    this.fetchDistinctValues(this.fullLinea, "Model", ",", this.idTipologia, "ND", "ND").then(
      result => {
        this.modelList = result as string[];
        this.modelList = this.modelList
          .map(s => s.trim())  // trim
          .filter((value, index, self) => self.indexOf(value) === index)  // unique
          .sort().reverse();  // sort
        // console.log(this.modelList);
        let translateKey = "INTERNATIONALACTIVITIES.ALLMODELS";
        this.translate.get([translateKey])
          .subscribe(values => {
            this.modelList.unshift(values[translateKey]);           
          });
        if (this.modelList[1] == "") {
        this.modelList.splice(1, 1);
        }
        this.selected.model = this.modelList[0];
        this.models = this.modelList;
      }, error => {
        console.error('error on get Models', error);
      });

    // Questo è veramente un casino:
    // quanto viene caricato service-ita.component tramite il routing personale del modulo, si inserisce nel dataService il nome del titolo del componente
    // a questo ComponentInput si sottoscrive il padre di di service-ita, cioè custom-layout.component, che renderizza il titolo in alto
    this.dataService.ComponentInput = 'INTERNATIONALACTIVITIES.TITLE';
    const url = 'api/rest/GetModelByIdTipologia';
    const input = {
      params: { idtipologia: this.idTipologia, azienda: 'InternationalActivities' }
    };
    this.tipologiaService.getData(url, input, false).subscribe(data => {
     // console.log('I data from observable tipologia user manuals arcadoc', data);
      this.tipologia = data;
    });
    this.modelList.sort();
          this.documentType = this.modelList[0];
        }

      });
    });
  }

  setDocumentType(docType) {
   // console.log('doctype', docType);
    this.selected.model = docType;
  }

  /* Evolutive Maggio Giugno Luglio 2021: Dropdown filtro model dinamica alla pressione di tasti */
  onSearchChange(searchValue: string): void {
    if (searchValue != null && searchValue != undefined && searchValue.length >= 1) {
      this.modelsFiltered = this.models.filter(x => x != null && x != undefined && x != "" && x.toLowerCase().includes(searchValue.toLowerCase()));
    } else {
      this.modelsFiltered = [];
    }
  }

  setModelToShowResult(model: string): void {
      this.selected.model = model;
  }


  /* Evolutive Maggio Giugno Luglio 2021: Filtro campo Arcadoc In Produzione / Discontinued / All */
  onCheckBoxChange(CheckBoxValue: string): void {
    if (CheckBoxValue != null && CheckBoxValue != undefined && CheckBoxValue != "") {
      if (CheckBoxValue == 'prod') {
        this.AllElement.nativeElement.checked = false;
        this.DiscElement.nativeElement.checked = false;
      }
      if (CheckBoxValue == 'disc') {
        this.AllElement.nativeElement.checked = false;
        this.ProdElement.nativeElement.checked = false;
      }
      if (CheckBoxValue == 'all') {
        this.ProdElement.nativeElement.checked = false;
        this.DiscElement.nativeElement.checked = false;
      }

      this.fetchDistinctValues(this.fullLinea, "Model", ",", this.idTipologia, "ND", CheckBoxValue).then(
        result => {
          this.modelList = result as string[];
          this.modelList = this.modelList
            .map(s => s.trim())  // trim
            .filter((value, index, self) => self.indexOf(value) === index)  // unique
            .sort().reverse();  // sort
         // console.log(this.modelList)
          let translateKey = "INTERNATIONALACTIVITIES.ALLMODELS";
          this.translate.get([translateKey])
            .subscribe(values => {
              this.modelList.unshift(values[translateKey]);
              this.selected.model = this.modelList[0];
              this.models = this.modelList;
            });
          if (CheckBoxValue == 'prod' || CheckBoxValue == 'disc') {
            this.modelList.shift();
          } 
        }, error => {
          console.error('error on get Models', error);
        });


    }
  }


  /* Evolutive Maggio Giugno Luglio 2021: Filtro ricerca fulltext */
  onTextSearchChange(searchValue: string): void {
    if (searchValue != null && searchValue != undefined && searchValue != "") {
     // console.log(searchValue);
      this.selected.textToSearch = searchValue;
    } else {
      this.selected.textToSearch = "";
    }
  }

  /* Evolutive Maggio Giugno Luglio 2021: Filtro dropdown classification: si refresha alla selezione del model */
  setSelectedModel(model: string): void {
      this.modelSelected = model;
  }

  /* Evolutive Maggio Giugno Luglio 2021: Dscription Link CloudBox cliccabile apre il link agli allegati CloudBox
  SubmitForm riceve [Link]**%%%%**[DescriptionLink]**%%%%**[PasswordLink]
  Ma per esigenze di rendering Link e Description link sono stati invertiti
  Modificato per le evolutive del Maggio 2023 per memorizzare su Arcadoc le letture dei link da parte degli utenti
  */

  submitForm = (values: string, iddocumento) => {
    if (values != null && values != undefined && values != "") {
      const valuesArray = values.split('**%%%%**');
      if (valuesArray[2] !== undefined) {
        this.DynamicFormElement.nativeElement.action = valuesArray[1];
        this.DynamicInputElement.nativeElement.value = valuesArray[2];
        this.DynamicFormElement.nativeElement.submit();
        /* Da qui evolutive del Maggio 2023 */
        let descrizioneLinkModified = valuesArray[0].replace("<u>", "").replace("</u>", "");
        let linkToCall = valuesArray[1];
        let url = 'api/rest/setLetturaLinkInternationalActivitiesInArcadoc';
        let input = { iddocumento: iddocumento, link: linkToCall, descrizionelink: descrizioneLinkModified };
        this.documentService.postData(url, input, false).subscribe(result => {
        }, error => console.error('error ', error));
      }
    }
  }


  fetchDistinctValues = (area: string, customtag: string, seperator: string, idTipologia: number, model: string, inProduction: string) => {
    return new Promise((resolve, reject) => {
      let url = 'api/rest/GetDistinctCustomValues';
      let params = { params: { IdTipologia: idTipologia, customtag: customtag, model: model, inProduction: inProduction  } };
      this.distinctValueService.getData(url, params, false).subscribe(result => {
        if (result) {
          let items = result as CustomValue[];
          let list: string[] = [];
          items.forEach(x => {
            x.value.split(seperator).forEach(v => {
              list.push(v);
            })
          })
          resolve(list);
        }
      }, error => reject(error));
    })
  }

  callBarcadoc(textTosearch: string) {
    // console.log('textTosearch' + textTosearch);
    const url = 'api/rest/LoadFilteredDocuments'; 
    if (this.selected.model == "All models") {
      this.filter = ""
    } else {
      this.filter = this.tipologia.labelCampoModel + ',' + this.selected.model;
  }
    const input = { idtipologia: this.tipologia.idTipologia, customtag: this.filter };  // Attenzione così gestisce un solo filtro. Per più di un filtro usare '#' come separatore filtri
    //console.log("input  " + input.idtipologia + " " + input.customtag)
      this.documentService.postData(url, input, false).subscribe(result => {
        if (result) {
          let link1;
          let description1;
          let link2;
          let description2;
          let link3;
          let description3;

        //  console.log('this is documents : ', result);
          this.documents = result as Documento[];

          this.documents.forEach((x, i) => {

            /* Filtro ricerca fulltext */
            
            x.isCollapsed = true;
            x.metadatiDtoList.forEach(item => {
      
              /* Traduzione delle label richiesta dal cliente: Traduco "a mano", queste label arrivano direttamente dal db di arcadoc e lì è pericoloso modificarle */
              let itemN = item.key.replace(/_/g, " ");
              let ItemEng = "";
              switch (itemN) {
                case "Data termine validita del documento":
                  ItemEng = "Document validity end date";
                  break;
                case "Stato del documento":
                  ItemEng = "Status of the document";
                  break;
                case "Status del documento":
                  ItemEng = "Status of the document";
                  break;
                case "Descrizione Link 1":
                  ItemEng = "Description link 1";
                  break;
                case "Descrizione link 1":
                  ItemEng = "Description link 1";
                  break;
                case "Descrizione Link 2":
                  ItemEng = "Description link 2";
                  break;
                case "Descrizione link 2":
                  ItemEng = "Description link 2";
                  break;
                case "Descrizione Link 3":
                  ItemEng = "Description link 3";
                  break;
                case "Descrizione link 3":
                  ItemEng = "Description link 3";
                  break;
                case "GlobalServiceMarketing":
                  ItemEng = "Status of the document";
                  break;
                default:
                  ItemEng = itemN;
              }
              item.key = ItemEng;

              /* Dscription Link CloudBox cliccabile apre il link agli allegati CloudBox
              Nel seguente codice mi baso sul fatto che i campi arrivano in ordine per come sono nella tipologia in arcadoc:
              1: Link
              2: Description Link
              3: Password Link
              Link e Description sono memorizzati in due variabili. Quando passa Password Link rinomino la label (Key) in Description link e butto
              come valore (value) la stringa [Link]**%%%%**[DescriptionLink]**%%%%**[PasswordLink]. Nell'html mi curo di mandare a video solo la Description con uno split
              ma devo buttare tutti e tre i valori, perchè al click della description (ciò è richiesto dal cliente) dovrò inviare in un colpo solo Link e password a submitForm.
              Questa è la soluzione trovata per farlo dinamicamente per decine di record che sono letti da un foreach.
              */
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'link 1' && item.value != null && item.value != "" && item.value != undefined && item.value.trim() != "") {
                link1 = item.value
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == ('description link 1') && item.value != null && item.value != undefined && item.value.trim() != "") {
                item.value = '<u>' + item.value + '</u>'
                description1 = item.value
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 1' && item.value != null && item.value != undefined && item.value.trim() != "" && item.value.length > 19) {
                let message = "";
                message = item.value.substring(15);
                message = message.substring(0, message.length - 14);
                message = this.Reverse(message);
                item.key = "Link 1 description (click here on the side)";
                if (description1 == undefined && link1 != undefined) {
                  description1 = '<u>Link</u>'
                } else if (description1 == undefined && link1 == undefined) {
                  item.key = '';
                }
                item.value = description1 + "**%%%%**" + link1 + "**%%%%**" + message;
                link1 = undefined;
                description1 = undefined;
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 1' && link1 != undefined && description1 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
                item.key = "Link 1 description (click here on the side)";
                item.value = description1 + "**%%%%**" + link1 + "**%%%%**" + '';
                link1 = undefined;
                description1 = undefined;
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 1' && link1 != undefined && description1 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
                item.key = "Link 1 description (click here on the side)";
                description1 = '<u>Link</u>'
                item.value = description1 + "**%%%%**" + link1 + "**%%%%**" + '';
                link1 = undefined;
                description1 = undefined;
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 1' && link1 == undefined && description1 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
                item.key = "Link 1 description (click here on the side)";
                item.value = description1 + "**%%%%**" + link1 + "**%%%%**" + '';
                link1 = undefined;
                description1 = undefined;
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 1' && link1 == undefined && description1 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
                item.key = '';
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'link 2' && item.value != null && item.value != undefined && item.value.trim() != "") {
                link2 = item.value
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'description link 2' && item.value != null && item.value != undefined && item.value.trim() != "") {
                item.value = '<u>' + item.value + '</u>'
                description2 = item.value
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 2' && item.value != null && item.value != undefined && item.value.trim() != "" && item.value.length > 19) {
                let message = "";
                message = item.value.substring(15);
                message = message.substring(0, message.length - 14);
                message = this.Reverse(message);
                item.key = "Link 2 description (click here on the side)";
                if (description2 == undefined && link2 != undefined) {
                  description2 = '<u>Link</u>'
                } else if (description2 == undefined && link2 == undefined) {
                  item.key = '';
                }
                item.value = description2 + "**%%%%**" + link2 + "**%%%%**" + message;
                link2 = undefined;
                description2 = undefined;
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 2' && link2 != undefined && description2 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
                item.key = "Link 2 description (click here on the side)";
                item.value = description2 + "**%%%%**" + link2 + "**%%%%**" + '';
                link2 = undefined;
                description2 = undefined;
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 2' && link2 != undefined && description2 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
                item.key = "Link 2 description (click here on the side)";
                description2 = '<u>Link</u>'
                item.value = description2 + "**%%%%**" + link2 + "**%%%%**" + '';
                link2 = undefined;
                description2 = undefined;
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 2' && link2 == undefined && description2 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
                item.key = "Link 2 description (click here on the side)";
                item.value = description2 + "**%%%%**" + link2 + "**%%%%**" + '';
                link2 = undefined;
                description2 = undefined;
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 2' && link2 == undefined && description2 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
                item.key = '';
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'link 3' && item.value != null && item.value != "" && item.value != undefined) {
                link3 = item.value
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'description link 3' && item.value != null && item.value != "" && item.value != undefined) {
                item.value = '<u>' + item.value + '</u>'
                description3 = item.value
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 3' && item.value != null && item.value != "" && item.value != undefined && item.value.length > 19) {
                let message = "";
                message = item.value.substring(15);
                message = message.substring(0, message.length - 14);
                message = this.Reverse(message);
                item.key = "Link 3 description (click here on the side)";
                if (description3 == undefined && link3 != undefined) {
                  description3 = '<u>Link</u>'
                } else if (description3 == undefined && link3 == undefined) {
                  item.key = '';
                }
                item.value = description3 + "**%%%%**" + link3 + "**%%%%**" + message;
                link3 = undefined;
                description3 = undefined;
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 3' && link3 != undefined && description3 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
                item.key = "Link 3 description (click here on the side)";
                item.value = description3 + "**%%%%**" + link3 + "**%%%%**" + '';
                link3 = undefined;
                description3 = undefined;
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 3' && link3 != undefined && description3 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
                item.key = "Link 3 description (click here on the side)";
                description3 = '<u>Link</u>'
                item.value = description3 + "**%%%%**" + link3 + "**%%%%**" + '';
                link3 = undefined;
                description3 = undefined;
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 3' && link3 == undefined && description3 != undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
                item.key = "Link 3 description (click here on the side)";
                item.value = description3 + "**%%%%**" + link3 + "**%%%%**" + '';
                link3 = undefined;
                description3 = undefined;
              }
              if (item.key != null && item.key != "" && item.key != undefined && item.key.toLowerCase() == 'password link 3' && link3 == undefined && description3 == undefined && item.value != null && item.value != undefined && item.value.trim() == '') {
                item.key = '';
              }
            });
            x.bg = 'mat-card-header-gray';//this.bgColors[this.getRandomBgIndex()];               
            x.active = 'titleTab';
          });
        }
      }, error => console.error('error on get documenti', error));
    }

  setFlagLetturaInArcadoc(iddocumento) {
    const url = 'api/rest/setFlagLetturaInArcadoc';
    const input = { iddocumento: iddocumento };
    this.documentService.postData(url, input, false).subscribe(result => {
     // console.log('Setflaglettura esguito: ' + result);
    }, error => console.error('error ', error));
  }

  dataURIToBlob = (dataURI, mimeString) => {
    return new Promise(resolve => {
      const binStr = atob(dataURI),
        len = binStr.length,
        arr = new Uint8Array(len)
      for (let i = 0; i < len; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      const result = new Blob([arr], {
        type: mimeString
      });
      resolve(result)
    })
  }

  Reverse(str: string) {
    let newString = "";
    for (let i = str.length - 1; i >= 0; i--) {
      newString += str[i];
    }
    return newString;
  }

  getArcadocAttach(item: AttachmentDto, iddocumento, download: boolean) {
    let url = 'api/rest/GetAttachment';
    let params = { params: { idAllegato: item.idAllegato, idDocument: iddocumento, fileName: item.nomeFile, download: download } };
    this.fileServer.getData(url, params, false).toPromise().then(res => {
      //console.log(res);
      let attachment: AttachmentDto = res as AttachmentDto;
      let ext = attachment.nomeFile.split('.').pop();
      const downloadLink = document.createElement("a");
      const fileName = attachment.nomeFile;
      this.dataURIToBlob(attachment.data, this.mimeTypeService.getMimeType(ext)).then(blob => {
        let url = URL.createObjectURL(blob);
        if (download) {
          downloadLink.href = url;
          downloadLink.download = fileName;
          downloadLink.click();
        } else {
          window.open(url, '_blank')
        }
      })
    });
  }
}
